module.exports = __webpack_public_path__ + "img/shakeys_woodbridge_today_1.4df9f4e2.jpg";